/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Made by Mateusz Janeczek
 **/
import React from 'react';
import s from './Popup.scss';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import infoIcon from './legend.png';

class Popup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayPopup: false,
    };
  }

  showPopup = () => {
    if (this.state.displayPopup) {
      this.setState({ displayPopup: false });
    } else {
      this.setState({ displayPopup: true });
    }
  }
  
  render() {
    const popupStyle = this.state.displayPopup ? "popuptext show" : "popuptext";
    return (
      <div className="popup" onMouseOver={() => this.showPopup()} onMouseOut={() => this.showPopup()}>
        <span className="glyphicon glyphicon-info-sign legend-icon"></span>
        <span className={popupStyle} >{this.props.opisWarstwy}</span>
      </div>
    );
  }
}

export default withStyles(s)(Popup);



// WEBPACK FOOTER //
// src/components/Modals/LayersModal/Popup.js